import React from 'react';
import { Box, Typography, useTheme, Alert } from "@mui/material";
import { tokens } from "../theme";
import { useState } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider, Grid } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import SavingsDetails from '../components/SavingsDetails';
import LoansDetails from '../components/LoansDetails';
import SharesDetails from '../components/SharesDetails';
import FileOpenIcon from '@mui/icons-material/FileOpen';
// import CommodityDetails from '../components/CommodityDetails';


// {accounts.All_Savings_account?.map((savingsItem, index) => (
//     <>
//     <Link
//         sx={{ display:'flex' }}
//         key={index}
//         variant="h6"
//         underline="none"
//         component='button'
//         color="inherit"
//         onClick={() => handleSave(savingsItem.id, savingsItem.account_name, savingsItem.current_balance, savingsItem.member_id)}
//     >
//         <Typography sx={{ fontWeight:'600'}}>{savingsItem.firstname} {savingsItem.lastname} ({savingsItem.account_name})</Typography>
//         <Typography sx={{ fontWeight:'600', ml:'55px' }}>GH₵{savingsItem.current_balance}.00</Typography>
        
//     </Link>
//     <Divider variant='middle' sx={{marginBottom:'10px'}} />
//     </>
// ))}


// {accounts.All_Loans_account?.map((savingsItem, index) => (
//     <>
//     <Link
//         sx={{ display:'flex' }}
//         key={index}
//         variant="h6"
//         underline="none"
//         component='button'
//         color="inherit"
//         onClick={() => handleLoan(savingsItem.id, savingsItem.account_name)}
//     >
        
//         <Typography sx={{ fontWeight:'600'}}>{savingsItem.firstname} {savingsItem.lastname} ({savingsItem.account_name})</Typography>
//         <Typography sx={{ fontWeight:'600', ml:'55px' }}>GH₵{savingsItem.current_balance}.00</Typography>
//     </Link>
//     <Divider variant='middle' sx={{marginBottom:'10px'}} />
//     </>
// ))}



// {accounts.All_Shares_acount?.map((savingsItem, index) => (
//     <>
// <Link
//     sx={{ display:'flex' }}
//     key={index}
//     variant="h6"
//     underline="none"
//     component='button'
//     color="inherit"
//     onClick={() => handleShare(savingsItem.id, savingsItem.account_name)}
// >
    
//     <Typography sx={{ fontWeight:'600'}}>{savingsItem.firstname} {savingsItem.lastname} ({savingsItem.account_name})</Typography>
//     <Typography sx={{ fontWeight:'600', ml:'55px' }}>GH₵{savingsItem.current_balance}.00</Typography>
// </Link>
// <Divider variant='middle' sx={{marginBottom:'10px'}} />
// </>
// ))}




// {accounts.All_Commodity_account?.map((savingsItem, index) => (
//     <>
// <Link
//     sx={{ display:'flex' }}
//     key={index}
//     variant="h6"
//     underline="none"
//     component='button'
//     color="inherit"
//     onClick={() => handleCommodity(savingsItem.id, savingsItem.warehouse)}
// >
    
//     <Typography sx={{ fontWeight:'600'}}>{savingsItem.firstname} {savingsItem.lastname} ({savingsItem.warehouse})</Typography>
//     <Typography sx={{ fontWeight:'600', ml:'55px' }}>Amount of Commodities:{savingsItem.amt_valued}</Typography>
// </Link>
// <Divider variant='middle' sx={{marginBottom:'10px'}} />
// </>
// ))}







const PassbookInAssociation = () => {
    const [theme, colorMode] = useMode();
    const location = useLocation();
    const themee = useTheme();
    const association_name = location.state && location.state.association_name;
    const alld = location.state && location.state.All;
    const type = location.state && location.state.type;
    const [open_acc, setOpen_acc] = useState();
    const [alert, setAlert] = useState()

    
    const columns = [
        {
            field: "id",
            headerName: "Id",
            flex:1,
        },
        {
            field: "member_id",
            headerName: "member_Id",
            flex:1,
        },
        {
            field: "firstname",
            headerName: "firstname",
            flex:1,
        },
        {
            field: "lastname",
            headerName: "lastname",
            flex:1,
        },
        {
            field: "fullname",
            headerName: "Owner",
            flex:1,
            renderCell:params => `${params.row.firstname} ${params.row.lastname}`
        },
        {
            field: "account_name",
            headerName: "Account Name",
            flex:1,
        },
        {
            field: "current_balance",
            headerName: "Current Balance(GHS)",
            flex:1,
            renderCell:params => (params.row.current_balance === null)? 0 : params.row.current_balance
        },
        {
            field: 'do',
            type: 'actions',
            headerName: "TRS",
            getActions: (params: GridRowParams) => [
            <GridActionsCellItem
            icon={<FileOpenIcon />}
            onClick={() => handleClick(params.row.id, params.row.member_id, params.row.account_name, params.row.current_balance)} 
            label="Open"
            />,]
        },
        // {
        //     field: "warehouse",
        //     headerName: "warehouse",
        //     flex:1,
        // },
        // {
        //     field: "current_balance",
        //     headerName: "Current Balance",
        //     flex:1,
        // },
    ]

    const handleClick = (id,ID,namee,balance) =>{
        if (type === "save"){
                if (open_acc == null)
                {
                setOpen_acc(<SavingsDetails ID= {id} member_id={ID} name={namee} balance={balance} setOpen_acc={setOpen_acc}/>)
                setAlert()
                }else{
                setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
                }
        }
        else if(type === "loan"){
            if (open_acc == null)
                {
                setOpen_acc(<LoansDetails ID={id} name={namee} setOpen_acc={setOpen_acc}/>)
                setAlert()
                }else{
                setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
                }
        }
        else if(type === "share"){
            if (open_acc == null)
            {
            setOpen_acc(<SharesDetails name={namee} ID={id} setOpen_acc={setOpen_acc}/>)
            setAlert()
            }else{
            setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
            }
        }
    }

    // Expand Commodity Account
    // const handleCommodity = (id,name) => {
    //     if (open_acc == null)
    //     {
    //       setOpen_acc(<CommodityDetails name={name} ID={id} setOpen_acc={setOpen_acc}/>)
    //       setAlert()
    //     }else{
    //       setAlert(<Alert severity="error">Close Current tab before opening another tab</Alert>)
    //     }
    //   }
    
    


  return (
      <div className="app">
        <main className="content">
            <Box sx={{ m:5 }}>
              {/* HEADER */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Passbooks" subtitle={`${association_name}'s Passbooks`} />
              </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} sx={{ marginBottom:5 }}>
                        <Typography
                            variant='h4'
                            sx={{ textAlign:'center', color:'darkblue', marginBottom:2  }}
                        >
                            {(type === "save")? "Saving Accounts": (type === "loan")? "Loan Accounts": (type === "share")? "Share Accounts": ""}
                        {alert}
                        </Typography>
                    
                        <DataGrid
                            rows={alld}
                            columns={columns}
                            autoHeight
                            checkboxSelection
                            getRowId={(row) => row.id}
                            slots={{ toolbar: GridToolbar }}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        id: false,
                                        lastname: false,
                                        firstname: false,
                                        member_id:false
                                    },
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} sx={{ marginTop:2 }}>
                        {open_acc}
                    </Grid>
                </Grid>


            </Box>
          </main>
            </div>
  )
}

export default PassbookInAssociation;